import axios from '@/common/utils/axios';
import { IBaseRepositroy } from '@/repositories/base/IBaseRepositroy';
import { IParams, IResponseType } from '@/common/interfaces/IHttp';
/**
 * 基础 Api
 * @params virtualPath 虚拟目录
 */
class BaseRepository implements IBaseRepositroy {
    /**
     * 请求baseurl
     * @type {string}
     */
    baseUrl: string;

    constructor() {
        this.baseUrl = `//${window.location.host}`; // 请求baseurl
    }

    /**
     * get 请求
     * @param params
     * @returns
     */
    get<T>(params: IParams): Promise<IResponseType<T>> {
        return axios.get(this.baseUrl + params.url, {
            params: params.data,
            withCredentials: true,
        });
    }

    /**
     * post 请求
     * @param params
     * @returns
     */
    post<T>(params: IParams): Promise<IResponseType<T>> {
        return axios.post(this.baseUrl + params.url, params.data, {
            withCredentials: true,
        });
    }

    /**
     * put 请求
     * @param params
     * @returns
     */
    put<T>(params: IParams): Promise<IResponseType<T>> {
        return axios.put(this.baseUrl + params.url, params.data, {
            withCredentials: true,
        });
    }

    /**
     * delete 请求
     * @param params
     * @returns
     */
    delete<T>(params: IParams): Promise<IResponseType<T>> {
        return axios.delete(this.baseUrl + params.url, {
            data: params.data,
            withCredentials: true,
        });
    }
}

export default BaseRepository;
